module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_9016.e8a0418c.png";